class User {
    id: string = '';
    username: string = '';
    is_customer: boolean = false;
    is_staff: boolean = false;
    is_superuser: boolean = false;
}

export default User;